const POST_TRANSFER_VOICEMAIL_OUTCOMES = new Set([
    'voicemail',
    'likely_voicemail',
]);

export function hasVoiceCallVoicemailBadge(call: {
    readonly direction?: string | null;
    readonly voicemail_detected?: boolean | null;
    readonly classic_voicemail?: boolean | null;
    readonly post_transfer_audio_outcome?: string | null;
}): boolean {
    if (call.voicemail_detected === true || call.classic_voicemail === true) {
        return true;
    }
    if (call.direction !== 'inbound') {
        return false;
    }
    return POST_TRANSFER_VOICEMAIL_OUTCOMES.has(
        call.post_transfer_audio_outcome ?? '',
    );
}
